import { Resource } from "react-admin";
import React from "react";

export default <Resource name="event_types" />;



// WEBPACK FOOTER //
// ./src/resources/EventTypes/index.js